import React, { useState, useEffect, useRef } from "react";
import { Table, Row, Col, Card, Button, Spinner } from "react-bootstrap";
// import { BiLogIn } from "react-icons/bi";
import { LuPenLine, LuTimer, LuSquareArrowOutUpRight, LuPlus } from "react-icons/lu";
import API from "../../../services/axiosInstance";
import { useForm } from 'react-hook-form';
import { Link } from "react-router-dom";
import { useParams, useLocation } from "react-router-dom";
import '../Pub-Instream-Setting-List/PubInstreamSettingList.css'
import Pagination from "../../common_modules/pagination";
import FilterBar from "../../common_modules/filter";
import { FormLoader, useFormLoader } from "../../common_modules/loader";
import Permission from "../../security/permission";
import { AUTH_CODE } from "../../security/authCodes";
// import useSubmitPrevent from "../../utils/SubmitPrevent";
import usePreventMultiClick from "../../utils/SubmitPrevent";
import { SearchIcon } from "../../common_modules/commonIcons";

const PubInstreamList = () => {
  const [allList, setAllList] = useState([]);
  const [instresmTag, setInstreamTag] = useState("");
  const [loading, setLoading] = useState(false);
  const [deactivateModal, setDeactivateModal] = useState(false);
  const [paginationData, setPaginationData] = useState({});
  const [searchConfig, setSearchConfig] = useState({});
  const [publisherName, setPublisherName] = useState("");

  // hooks
  const location = useParams();
  const { register, formState: { errors } } = useForm();
  const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook loader

  //global var
  const accId = location?.id;
  const accGuid = location?.guid;

  // const submittingRef = useSubmitPrevent();
  const { btnClicked, setBtnClicked } = usePreventMultiClick();

  const tableFields = [
    { label: "Id", value: "id", enableSorting: true, enableIcon: false },
    { label: "Name", value: "instream_label", enableSorting: true, enableIcon: true },
    { label: "Status", value: "status", enableSorting: false, enableIcon: false },
    { label: "Created", value: "created_on", enableSorting: true, enableIcon: false },
  ];

  const pubAllList = async (search, page, field = "", order = "") => {
    startLoading();
    try {
      const size = 20;
      const pubListRes = await API.get(`publisher/instream/setting/list/${accId}?search=${search}&page=${page}&size=${size}&field=${field}&order=${order}`);

      const data = pubListRes?.data?.data?.content;
      setPublisherName(pubListRes?.data?.name);
      //       if (data?.content) {
      //         setAllList(data?.content);

      //         const data = pubListRes?.data?.data;
      //         delete
      //         setPaginationData(data);
      //       }
      console.log(data);

      if (pubListRes.status === 200 && data) {
        setAllList(data);
        // save pagination information
        let pagination = pubListRes.data.data;
        delete pagination.content; //  remove data
        setPaginationData(pagination);
      } else {
        setAllList([]);
        setPaginationData({});
      }

    } catch (error) { console.error("API Error:", error); } finally {
      stopLoading();
    }
  }

  // Generate instream tag
  const generateInstreamTag = async (guid) => {
    if (btnClicked) return;
    setBtnClicked(true);
    startLoading();
    try {
      // if(submittingRef.current) return;
      // submittingRef.current = true;
      // startLoading();
      //  const tagResponse = await API.get(`/publisher/instream/setting/generate/tag/563b7edb-eca0-4c25-8f71-a6019d37ed43/9ec73409-1d3d-4e5e-942d-90c7290f74f8/false`);
      const tagResponse = await API.get(`/publisher/instream/setting/generate/tag/${guid}/${accGuid}/0`);
      console.log(tagResponse?.data?.data);
      setInstreamTag(tagResponse?.data?.data);
    } catch (error) {
      console.error(error);
      setInstreamTag("Failed to generate instream tag");
    } finally {
      // submittingRef.current = false;
      setBtnClicked(false);
      stopLoading();
    }
  }

  const nextPage = (nextPage) => {
    pubAllList("", nextPage, searchConfig?.orderField, searchConfig?.orderDir)
  }

  const onChangeSearch = (params) => {
    setSearchConfig(params)
    pubAllList(params.keyword, 0, params.orderField, params.orderDir); // API call
  }

  // useEffect(() => {
  //   pubAllList("", 0);
  // }, []);
  return (
    // <>
    <FormLoader isLoading={isLoading} text={"Loading..."}>
      <div className="breadCrumb gradient-bg">
        <Link to={'/dashboard'}><span>Home</span></Link>
        <Permission code={AUTH_CODE.accounts.publisherListing}>
          <Link to={'/active-publisher'}><span>Publisher</span></Link>
        </Permission>
        {/* <span>{publisherName}</span> */}
        <Link to={`/publisher/info/${accId}/${accGuid}`}><span>{publisherName}</span></Link>
        <span>Manage Instream Setting</span>
        {/* <span>{accId}</span> */}
      </div>
      {/* <Row className="filter">
        <Col md={6}>
          <div className="pubFilters">
            <Col md={2}> <label for="name" class="control-label">Name</label></Col>
            <Col md={6}><input type="text" placeholder="First name"  className="form-control" /></Col>
          </div>
        </Col>
        <Col md={6}>
          <div className="pubFilters">
            <Col md={3}> <label for="Company Name" class="control-label">Company Name</label></Col>
            <Col md={6}><input type="text" placeholder="Company Name"  className="form-control" /></Col>
          </div>
        </Col>
        <Col md={6}>
          <div className="pubFilters">
              <Col md={2}> <label for="sort_by" class="control-label">Sort By</label></Col>
              <Col md={6}>
                <select {...register("Title")} className="form-select" >
                  <option value="name">Name</option>
                  <option value="companyNames">Company Name</option>
                </select> 
              </Col>
          </div>
        </Col>
        <Col md={6}>
          <div className="pubFilters">
            <Col md={3}> <label for="order_by" class="control-label">Order By</label></Col>
            <Col md={6}>
              <select {...register("Title")} className="form-select" >
                <option value="name">Ascending</option>
                <option value="companyNames">Descending</option>
              </select>
            </Col>
          </div>
        </Col>    
       </Row> */}
      {
        instresmTag && (<Card className="mb-3">
          <div className="generateTag">
            <pre>{instresmTag}</pre>
          </div>
        </Card>)
      }
      <Card className="mb-3">
        {/* <div className="active-table-wrapper"> */}
        {/* <div className="table-scroll"> */}
        <div className="filter row">
          <Permission code={AUTH_CODE.instreamTagSetting.createSetting}>
            <Link to={`/publisher/add/instream-setting/${accId}/${accGuid}`} style={{ color: '#ffffff', textDecoration: 'none' }} className="">
              <Button variant="primary" className="mb-2 addBtn" style={{ width: "max-content" }}>
                Create Setting <LuPlus />
              </Button>
              {/* <button className="mt-3 mb-2" size="md" style={{ width: "max-content" }}>
                  Create Setting <FaPlus />
                </button> */}
            </Link>
          </Permission>
          <FilterBar fields={tableFields} onSearch={onChangeSearch} />
        </div>
        <div className="mt-0 table-wrapper mt-3">
          <Table striped bordered responsive hover size="sm" className="custom-table align-middle">
            <thead>
              <tr>
                {
                  tableFields?.map((item, i) => (
                    <th key={i}>
                      {item.label}
                      {item.enableIcon ? <SearchIcon className="ms-1" size={10} fill="white" /> : ""}
                    </th>
                  ))
                }
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {allList?.length > 0 ?
                allList?.map((list, index) => (
                  <tr key={index}>
                    <td>{list?.id}</td>
                    <td>{list?.name}</td>
                    <td style={{ textAlign: "center" }}>
                      <span className={`badge ${list?.status === 1 ? "active" : "inactive"}`}>
                        {list?.status === 1 ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td>{list?.createdOn?.split("T")[0]}</td>
                    <td>
                      <div className="d-flex gap-2 flex-nowrap activePubAllBtns justify-content-center" >

                        <Permission code={AUTH_CODE.instreamTagSetting.edit_UpdateInstreamSetting}>
                          <Link to={`/publisher/edit/instream-setting/${list?.id}/${accId}/${accGuid}`} state={list?.id}>
                            <button> Edit <LuPenLine /></button>
                          </Link>
                        </Permission>

                        <Permission code={AUTH_CODE.instreamTagSetting.scheduleInstream}>
                          <Link to={`/publisher/${list?.id}/${list?.guid}/${accId}/${accGuid}/scheduleInstream`}><button> Schedule Instream <LuTimer /> </button></Link>
                        </Permission>

                        <Permission code={AUTH_CODE.instreamTagSetting.generateInstreamTag}>
                          <button type="button" disabled={btnClicked} onClick={() => generateInstreamTag(list?.guid)}> Generate Instream Tag <LuSquareArrowOutUpRight /></button>
                        </Permission>

                      </div>
                    </td>
                  </tr>
                )) : <tr><td colSpan="13" style={{ textAlign: "center" }}>No Data available</td></tr>
              }
            </tbody>
          </Table>
        </div>
        {/* </div> */}
        {/* </div> */}
      </Card>
      <Pagination
        jumpPage={true}
        count={true}
        component={PubInstreamList.name}
        size={"sm"}
        paginationData={paginationData}
        nextPage={nextPage} />
    </FormLoader>
    // </>
  )
}

export default PubInstreamList;